import { AfterViewInit, Component, Input, OnChanges, OnInit, ViewChild } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';

@Component({
    selector: 'app-yellow-dash',
    templateUrl: './yellow-dash.component.html',
    styleUrls: ['./yellow-dash.component.scss'],
    standalone: false
})
export class YellowDashComponent {
  @Input() value: string | null | undefined;

  get displayValue(): string {
    return this.value ? this.value : '—';
  }
}

